import Gtm from '@grebban/gtm';

type ColorSelection = {
    colorHex: string,
    colorName: string,
    colorThumbnailUrl: string,
    id: string,
    name: string,
    sku: string,
};

export default (colorSelection: ColorSelection) => {
    Gtm.addDataLayerEvent('select_color', {
        optimizely: {
            id: colorSelection.id || '',
            name: colorSelection.name || '',
            sku: colorSelection.sku || '',
            colorName: colorSelection.colorName || '',
            colorHex: colorSelection.colorHex || '',
            colorThumbnailUrl: colorSelection.colorThumbnailUrl || '',
        },
    });
};
